/**
 * Save data in localstorage.
 */
export const cachedDataWithExpiration = async ({
  dni,
  expirationTime = 6000,
  key,
  getBasicSellerInformationCallback = () => undefined
}) => {
  const cachedData = localStorage.getItem(key)
  if (cachedData) {
    const { value, expiration } = JSON.parse(cachedData)
    if (Date.now() > expiration || dni !== value?.dni) {
      localStorage.removeItem(key)
      const newExpiration = Date.now() + expirationTime
      const data = await getBasicSellerInformationCallback()
      localStorage.setItem(key, JSON.stringify({ value: data, expiration: newExpiration }))

      return data
    }

    return value
  }
  const newExpiration = Date.now() + expirationTime
  const data = await getBasicSellerInformationCallback()
  localStorage.setItem(key, JSON.stringify({ value: data, expiration: newExpiration }))

  return data
}
